import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { homeCardHover, homeSectionPaper } from "../home/homeStyles";
import { communityDebatePath, publicDebatePath } from "../../utils/community";

const share = (counts = [], index) => {
  const total = counts.reduce((sum, count) => sum + Number(count || 0), 0);
  if (!total) return 0;
  return Math.round((Number(counts[index] || 0) / total) * 100);
};

const DebateCard = ({ debate, sport, publicView = false }) => {
  if (!debate) return null;
  const to = publicView
    ? publicDebatePath(debate)
    : communityDebatePath(sport, debate.slug || debate.id);
  const a = debate.candidates?.[0];
  const b = debate.candidates?.[1];

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        ...homeSectionPaper,
        ...homeCardHover,
        textDecoration: "none",
        color: "inherit",
        p: 2,
        display: "block",
      }}
    >
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: "0.12em" }}>
        Debate
      </Typography>
      <Typography variant="h6" fontWeight={800} sx={{ mt: 0.5 }}>
        {debate.question}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1.25 }}>
        {a?.name || "Candidate A"} {share(debate.voteCounts, 0)}% vs{" "}
        {b?.name || "Candidate B"} {share(debate.voteCounts, 1)}%
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {Number(debate.totalVotes || 0).toLocaleString()} votes
      </Typography>
    </Box>
  );
};

export default DebateCard;
